module.exports = __webpack_public_path__ + "img/sedan_parked.7533d897.svg";